import React from "react";
import { Link } from "react-router-dom";
import "../styles/Features.css";
import features1 from "../images/features1.png";
import features2 from "../images/features2.png";
import features3 from "../images/features3.png";
import features4 from "../images/features4.png";
import features5 from "../images/features5.png";
import features6 from "../images/features6.png";
import features7 from "../images/features7.png";
import features8 from "../images/features8.png";
import features9 from "../images/features9.png";
import features10 from "../images/features10.png";
import features11 from "../images/features11.png";

function Features() {
  const features = [
    {
      image: features1,
      title: "チャット",
      description: "お客様とのリアルタイムなコミュニケーションを実現",
    },
    {
      image: features2,
      title: "リッチメニュー",
      description: "見やすいメニューでユーザーの操作をサポート",
    },
    {
      image: features3,
      title: "ショップカード",
      description: "リピーターの獲得を促進",
    },
    {
      image: features4,
      title: "セグメント配信",
      description: "ユーザーの属性に応じたメッセージ配信が可能",
    },
    {
      image: features5,
      title: "アンケート",
      description: "お客様の声をリアルタイムで収集し、サービス改善に役立てる",
    },
    {
      image: features6,
      title: "メッセージ配信",
      description: "最適なタイミングでメッセージを配信",
    },
  ];

  const extraFeatures = [
    {
      image: features7,
      title: "予約システム",
      description:
        "Googleカレンダーと連携し、スムーズに予約の確認や管理ができる",
    },
    {
      image: features2,
      title: "リッチメニュー",
      description: "カテゴリごとに情報を整理し、目的に応じて直感的に操作できる",
    },
    {
      image: features8,
      title: "デジタル会員証",
      description: "会員証をデジタル化し、スマホで簡単に持ち運べる",
    },
    {
      image: features9,
      title: "決済機能",
      description: "LINEで簡単に決済ができ、スムーズな支払いが可能",
    },
    {
      image: features10,
      title: "注文システム",
      description: "チャット上で簡単に注文ができ、手軽に利用可能",
    },
    {
      image: features11,
      title: "混雑状況配信",
      description: "リアルタイムで混雑状況を配信し、利用者の利便性を向上",
    },
  ];

  return (
    <section className="features" id="features-section">
      <h2 className="features-title">基本機能</h2>
      <div className="features-cards">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <img
              src={feature.image}
              alt={feature.title}
              className="feature-image"
            />
            <h3 className="feature-card-title">{feature.title}</h3>
            <p className="feature-card-description">{feature.description}</p>
          </div>
        ))}
      </div>

      <div className="plus-icon">+</div>

      <div className="additional-info">
        <h3 className="additional-title">Linectオリジナル機能</h3>
        <p className="additional-description">
          以下に例をいくつかご紹介します。<br></br>
          必要に応じてさらに多彩な機能をお届けしますので、まずはお気軽にご相談ください。
        </p>

        <div className="features-cards">
          {extraFeatures.map((feature, index) => (
            <div className="feature-card" key={index}>
              <img
                src={feature.image}
                alt={feature.title}
                className="feature-image"
              />
              <h3 className="feature-card-title">{feature.title}</h3>
              <p className="feature-card-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
